<template>

  <aside class="main-sidebar sidebar-dark-primary elevation-4 " style="padding-top: 58px">
    <div class="sidebar">
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="true">


          <li class="nav-item has-treeview ">
            <a href="#" class="nav-link ">
              <i class="nav-icon fas fa-users purple"></i>
              <p>
                Employees
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/admin/users" class="nav-link">
                  <i class="fas fa-user"></i>
                  <p>
                    Users
                  </p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/admin/roles">
                  <i class="fas fa-user-lock"></i>
                  <p>
                    Roles
                  </p>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>

      </nav>
    </div>

  </aside>
</template>


<script>

export default {
  name: "SideBar.vue",
}
</script>
